import React from 'react';
import { Menu, Switch, Drawer, Button, Grid } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { MoonOutlined, SunOutlined, MenuOutlined } from '@ant-design/icons';

interface Props {
  darkMode: boolean;
  toggleDarkMode: () => void;
}

const { useBreakpoint } = Grid;

const Navbar: React.FC<Props> = ({ darkMode, toggleDarkMode }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const menuItems = [
    { label: 'Chumped App', key: '/' },
    { label: 'Shop', key: '/shop' },
    { label: 'Terms and Conditions', key: '/termsandconditions' },
    { label: 'Privacy Policy', key: '/privacypolicy' },
    { label: 'Community Guidelines', key: '/communityguidelines' },
    
  ];

  const renderMenu = (
    <Menu
      mode={isMobile ? 'vertical' : 'horizontal'}
      selectedKeys={[location.pathname]}
      theme="light"
      style={{
        flex: 1,
        justifyContent: isMobile ? 'start' : 'center',
        backgroundColor: 'transparent',
        borderBottom: 'none',
        fontSize: 15,
        fontWeight: 'bold',
      }}
      items={menuItems.map((item) => ({
        label: item.label,
        key: item.key,
        onClick: () => {
          navigate(item.key);
          if (isMobile) setDrawerOpen(false);
        },
      }))}
    />
  );

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '0 16px',
        backgroundColor: darkMode ? '#000' : '#fff',
        borderBottom: `2px solid ${darkMode ? '#333' : '#ddd'}`,
        height: 60,
        position: 'sticky',
        top: 0,
        zIndex: 100,
      }}
    >
      {/* Logo */}
      <div style={{ flex: 1, cursor: 'pointer' }} onClick={() => navigate('/')}>
        <img
          src="/logo.png"
          alt="logo"
          height={isMobile ? 40 : 55}
          style={{ filter: darkMode ? 'brightness(1.8)' : 'none' }}
        />
      </div>

      {/* Desktop Nav */}
      {!isMobile && renderMenu}

      {/* Theme Switch */}
      <div style={{ marginLeft: isMobile ? 'auto' : 5 }}>
        <Switch
          checkedChildren={<SunOutlined style={{ fontSize: 15 }} />}
          unCheckedChildren={<MoonOutlined style={{ fontSize: 15 }} />}
          checked={!darkMode}
          onChange={toggleDarkMode}
          style={{
            transform: 'scale(1.2)',
            marginLeft: 8,
          }}
        />
      </div>

      {/* Mobile Hamburger */}
      {isMobile && (
        <>
          <Button
            icon={<MenuOutlined />}
            type="text"
            style={{ marginLeft: 12 }}
            onClick={() => setDrawerOpen(true)}
          />
          <Drawer
            title="Menu"
            placement="right"
            onClose={() => setDrawerOpen(false)}
            open={drawerOpen}
            bodyStyle={{ padding: 0 }}
          >
            {renderMenu}
          </Drawer>
        </>
      )}
    </div>
  );
};

export default Navbar;
